import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCities, createCity, fetchCity, modifyCity, deleteCityApi, changeStatus } from '../../api/cityApi';

export const getCities = createAsyncThunk('city/getCities', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchCities(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addCity = createAsyncThunk('city/addCity', async (payload, { rejectWithValue }) => {
  try {
    const response = await createCity(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getCityDetails = createAsyncThunk('city/getCityDetails', async (cityId, { rejectWithValue }) => {
  try {
    const response = await fetchCity(cityId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateCity = createAsyncThunk('city/updateCity', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyCity(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteCity = createAsyncThunk('city/deleteCity', async (cityId, { rejectWithValue }) => {
  try {
    const response = await deleteCityApi(cityId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('city/changeActiveStatus', async (cityId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(cityId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const citySlice = createSlice({
  name: 'city',
  initialState: {
    cities: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cities = action.payload;
      })
      .addCase(getCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default citySlice.reducer;
